import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const exportToExcel = async (record, client) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Client Report");

    const thickBorder = { style: "thick" };

    // Title
    worksheet.addRow([client.name]);
    worksheet.mergeCells("A1:B1");
    const clientTitleCell = worksheet.getCell("A1");
    clientTitleCell.font = { bold: true, size: 22 };
    clientTitleCell.alignment = { horizontal: "center", vertical: "middle" };
    worksheet.getColumn("A").width = Math.max(20, client.name.length + 5);
    worksheet.getColumn("B").width = worksheet.getColumn("A").width;

    worksheet.addRow(["Report Date", new Date().toLocaleDateString()]);
    worksheet.addRow([]);

    // Event details
    const eventTitleRow = worksheet.addRow(["Event Details", ""]);
    eventTitleRow.font = { bold: true, size: 16 };
    ["A4", "B4"].forEach(cell => {
        worksheet.getCell(cell).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D6EAF8" } };
        worksheet.getCell(cell).alignment = { horizontal: "center" };
    });

    const eventRows = [
        ["Mnemonic", record.event_mnemonic],
        ["Begin Date", record.event_beginDate],
        ["End Date", record.event_endDate],
        ["Total Devices", Array.isArray(record.devices) ? record.devices.length : 0],

    ];

    eventRows.forEach(row => worksheet.addRow(row));

    const totalBillableRow = worksheet.addRow(["Total Billable Days", record.total_billable_days ?? "-"]);
    totalBillableRow.font = { bold: true, size: 14 };
    totalBillableRow.alignment = { vertical: "middle" };

    for (let row = 4; row <= 9; row++) {
        worksheet.getCell(`A${row}`).border = { left: thickBorder };
        worksheet.getCell(`B${row}`).border = { right: thickBorder };
    }

    worksheet.getCell("A4").border = { top: thickBorder, left: thickBorder, bottom: thickBorder };
    worksheet.getCell("B4").border = { top: thickBorder, right: thickBorder, bottom: thickBorder };
    worksheet.getCell("A9").border = { bottom: thickBorder, left: thickBorder };
    worksheet.getCell("B9").border = { bottom: thickBorder, right: thickBorder };

    worksheet.addRow([]);

    // Header configurations
    const configStartRow = worksheet.rowCount + 1;
    const configHeaderRow = worksheet.addRow([
        "Serial Number", "Device Name", "Type", "Config Name", "Used On", "Programme Point", "Days Assigned"
    ]);
    configHeaderRow.font = { bold: true, size: 14 };
    ["A", "B", "C", "D", "E", "F", "G"].forEach(col => {
        worksheet.getCell(`${col}${configStartRow}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "D6EAF8" }
        };
    });

    // Configuration data
    if (Array.isArray(record.devices)) {
        record.devices.forEach(device => {
            const configs = Array.isArray(device.configs) ? device.configs : [];

            configs.forEach((config, index) => {
                const row = worksheet.addRow([
                    index === 0 ? device.serialNumber : "",
                    index === 0 ? device.name : "",
                    index === 0 ? device.type : "",
                    config.name || "-",
                    config.usedOn ? new Date(config.usedOn).toLocaleDateString() : "-",
                    config.selectedProgrammePointName || "-",
                    (config.billable === 1 || config.billable === "1")
                        ? "BILLABLE"
                        : (config.billable || "").toString().toLowerCase() === "not billable"
                            ? "NOT BILLABLE"
                            : config.billable ?? "-"
                ]);

                const value = worksheet.getCell(`G${row.number}`);
                if (value.value === "NOT BILLABLE") {
                    value.font = { color: { argb: "FF0000" }, bold: true };
                } else if (value.value === "BILLABLE") {
                    value.font = { color: { argb: "008000" }, bold: true };
                }
            });
        });
    }

    const configEndRow = worksheet.rowCount;

    for (let row = configStartRow; row <= configEndRow; row++) {
        worksheet.getCell(`A${row}`).border = { left: thickBorder };
        worksheet.getCell(`G${row}`).border = { right: thickBorder };
    }

    ["A", "B", "C", "D", "E", "F", "G"].forEach(col => {
        worksheet.getCell(`${col}${configStartRow}`).border = {
            top: thickBorder,
            bottom: thickBorder
        };
    });

    worksheet.getCell(`A${configStartRow}`).border = {
        ...worksheet.getCell(`A${configStartRow}`).border,
        left: thickBorder
    };
    worksheet.getCell(`G${configStartRow}`).border = {
        ...worksheet.getCell(`G${configStartRow}`).border,
        right: thickBorder
    };

    ["A", "B", "C", "D", "E", "F", "G"].forEach(col => {
        worksheet.getCell(`${col}${configEndRow}`).border = {
            bottom: thickBorder
        };
    });

    worksheet.getCell(`A${configEndRow}`).border = {
        ...worksheet.getCell(`A${configEndRow}`).border,
        left: thickBorder
    };
    worksheet.getCell(`G${configEndRow}`).border = {
        ...worksheet.getCell(`G${configEndRow}`).border,
        right: thickBorder
    };

    worksheet.addRow([]);

    // Adjust column width
    worksheet.columns.forEach(column => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, cell => {
            const cellValue = cell.value ? cell.value.toString() : "";
            maxLength = Math.max(maxLength, cellValue.length);
        });
        column.width = maxLength + 2;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `ClientReport_${client.name}_${record.event_mnemonic}.xlsx`);
};